import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Trash.svg'

export const IconTrash = IconSVG as IconComponent
